export const normalizeAloApiPreviewHostUrl = (previewHostUrl: string | Record<string, never>): string | null => {
  if (typeof previewHostUrl !== 'string') return null;

  const trimmedPreviewHostUrl = previewHostUrl.trim();

  if (!trimmedPreviewHostUrl) return null;

  const candidateUrl = /^[a-z]+:\/\//i.test(trimmedPreviewHostUrl)
    ? trimmedPreviewHostUrl
    : `https://${trimmedPreviewHostUrl}`;

  try {
    const normalizedUrl = new URL(candidateUrl);
    if (normalizedUrl.protocol !== 'https:') return null;

    const normalizedPath = normalizedUrl.pathname.replace(/\/$/, '');
    const aloApiPath = normalizedPath.endsWith('/alo-api') ? normalizedPath : `${normalizedPath}/alo-api`;
    return `${normalizedUrl.origin}${aloApiPath}`;
  } catch {
    return null;
  }
};
